// extracted by mini-css-extract-plugin
export default {"container":"lk-z","blurb":"mk-z","links":"nk-z"};